import styled from '@emotion/styled';
import React from 'react';
import {
  background,
  border,
  color,
  compose,
  display,
  flexbox,
  layout,
  position,
  shadow,
  space,
  typography,
  BackgroundProps,
  BorderProps,
  ColorProps,
  DisplayProps,
  FlexProps,
  LayoutProps,
  PositionProps,
  ShadowProps,
  SpaceProps,
  TypographyProps,
} from 'styled-system';
import { defineWithTheme, CoreBaseProps } from '../../theming';

export interface BaseListProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    FlexProps,
    LayoutProps,
    PositionProps,
    ShadowProps,
    SpaceProps,
    TypographyProps {}
export const List = styled('ul')<BaseListProps>(
  (_props) => `
    list-style: none;
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    font: inherit;
  `,
  defineWithTheme('lists'),
  compose(
    background,
    border,
    color,
    display,
    flexbox,
    layout,
    position,
    shadow,
    space,
    typography
  )
);

export default List;
export type ListProps = React.ComponentPropsWithRef<typeof List>;
